var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookGreyIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161036",
    "data-name": "Group 161036",
    transform: "translate(-218 -308.519)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FB",
    transform: "translate(-86 100.519)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_743",
    "data-name": "Path 743",
    d: "M22,11A11,11,0,1,0,9.281,21.866V14.18H6.488V11H9.281V8.577c0-2.757,1.642-4.28,4.155-4.28a16.749,16.749,0,0,1,2.462.217V7.221H14.511a1.59,1.59,0,0,0-1.793,1.718V11h3.05l-.487,3.18H12.718v7.684A11,11,0,0,0,22,11Z",
    transform: "translate(304 208)",
    fill: "#a6a8bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_744",
    "data-name": "Path 744",
    d: "M158.291,108.9l.488-3.186h-3.058v-2.067a1.594,1.594,0,0,1,1.8-1.721h1.389v-2.71A16.782,16.782,0,0,0,156.44,99c-2.517,0-4.163,1.526-4.163,4.288v2.428h-2.8V108.9h2.8v7.7a11.138,11.138,0,0,0,3.444,0v-7.7Z",
    transform: "translate(160.999 113.263)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookGreyIcon);
export default __webpack_public_path__ + "static/media/facebook-grey-icon.77714174b17c325e8abb8f74d3381b8a.svg";
export { ForwardRef as ReactComponent };